import { useEffect, useState } from 'react'
import { useSearch } from 'wouter'
import queryString from 'query-string'

import { Dialog } from '@/components/ui/dialog'
import { Spinner } from '@/components/ui/spinner'
import { useDocumentPageQuery } from '../DocumentPage/queries'
import { ProjectTracker } from '../DocumentPage/components/Documents/ProjectTracker'
import { WorkInstructions } from '../DocumentPage/components/Documents/WorkInstructions'
import { DownloadPDFDialogContent } from '@/components/collaborating/PDFDownloadButton/DownloadPDFDialogContent'
import { usePDFDownloadEnabled } from '@/components/collaborating/PDFDownloadButton/hooks/usePDFDownloadEnabled'
import { usePDFDownloadTrigger } from '@/components/collaborating/PDFDownloadButton/hooks/usePDFDownloadTrigger'

export const PDFPage = () => {
  const searchParams = useSearch()
  const enabled = usePDFDownloadEnabled()
  const triggerDownload = usePDFDownloadTrigger()
  const { isLoading, data } = useDocumentPageQuery()
  const [isRendered, setIsRendered] = useState(false)
  const { triggerPrint, openDialog, size } = queryString.parse(
    searchParams,
  ) as {
    triggerPrint?: boolean
    openDialog?: boolean
    size?: string
  }

  useEffect(() => {
    if (enabled) {
      triggerDownload()
        .then(() => {
          document.querySelectorAll('img[loading="lazy"]').forEach((img) => {
            img.setAttribute('loading', 'eager')
          })

          setTimeout(() => {
            setIsRendered(true)
          }, 100)
        })
        .catch((error) => {
          console.error('Error triggering download:', error)
        })
    }
  }, [enabled, openDialog, triggerDownload])

  useEffect(() => {
    if (isRendered && triggerPrint) window.print()
  }, [isRendered, triggerPrint])

  if (isLoading) {
    return (
      <div
        data-testid="pdf-download-spinner"
        className="flex items-center justify-center w-full h-screen"
      >
        <Spinner />
      </div>
    )
  }

  return (
    <>
      {openDialog && !isRendered && (
        <Dialog open={!isRendered}>
          <DownloadPDFDialogContent />
        </Dialog>
      )}

      <div className="w-full h-screen bg-white print:h-auto">
        <style>
          {`
          @media print {
            @page {
              size: ${size ? size : 'a5 landscape'};
              margin: 0;
            }
            body {
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
          }
          [data-placeholder] {
            display: none !important;
          }
          [data-disableprint] {
            display: none !important;
          }
        `}
        </style>
        {data?.documentType === 'project_tracker' ? (
          <ProjectTracker />
        ) : (
          <WorkInstructions />
        )}
      </div>
    </>
  )
}
